

import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';

const SrServiceFaq = () => {
    const accordionRefs = useRef([]);

    useEffect(() => {
        const accordionBoxes = document.querySelectorAll('.accordion_box');

        accordionBoxes.forEach((accordionBox) => {
            const accBtns = accordionBox.querySelectorAll('.acc-btn');

            accBtns.forEach((accBtn, index) => {
                const accBody = accBtn.nextElementSibling;
                accordionRefs.current[index] = accBody;

                let isAnimating = false; // Flag to prevent multiple clicks during animation

                const handleClick = () => {
                    if (isAnimating) return; // Prevent clicks during animation
                    isAnimating = true;

                    const target = accBtn.closest('.accordion');
                    const outerBox = accBtn.closest('.accordion_box');

                    if (accBtn.classList.contains('active')) { // Check class directly
                        gsap.to(accBody, {
                            duration: 0.3,
                            height: 0,
                            paddingTop: 0,
                            paddingBottom: 0,
                            onComplete: () => {
                                accBody.style.display = 'none';
                                accBtn.classList.remove('active');
                                target.classList.remove('active-block');
                                isAnimating = false; // Reset flag after animation
                            },
                        });
                    } else {
                        // Close other open accordions (with animation)
                        outerBox.querySelectorAll('.acc-btn').forEach((btn, otherIndex) => {
                            if (btn.classList.contains('active')) {
                                gsap.to(accordionRefs.current[otherIndex], {
                                    duration: 0.3,
                                    height: 0,
                                    paddingTop: 0,
                                    paddingBottom: 0,
                                    onComplete: () => {
                                        accordionRefs.current[otherIndex].style.display = 'none';
                                        btn.classList.remove('active');
                                        btn.closest('.accordion').classList.remove('active-block');

                                    },
                                });
                            }
                        });


                        accBody.style.display = 'block';
                        gsap.fromTo(
                            accBody,
                            { height: 0, paddingTop: 0, paddingBottom: 0 },
                            { duration: 0.3, height: 'auto', paddingTop: '10px', paddingBottom: '10px',
                            onComplete: () => {
                                accBtn.classList.add('active');
                                target.classList.add('active-block');
                                isAnimating = false; // Reset flag after animation
                            }, }
                        );

                    }
                };

                accBtn.addEventListener('click', handleClick);

                return () => {
                    accBtn.removeEventListener('click', handleClick);
                };
            });
        });
    }, []);

    return (
        <section className="faq z-3 pt-80 pb-70 pos-rel">
            <div className="container">
                <div className="section-title mb-30">
                    <span className="sub-title wow fadeInRight" data-wow-duration=".7s">WHAT WE OFFER</span>
                    <h3 className="title xb-split-text split-in-right">Discover Our <br /> <span>Capabilities</span></h3>
                </div>
                <div className="row">
                    <div className="col-lg-6">
                        <div className="accordion-wrapper">
                            <ul className="accordion_box clearfix">
                                <li className="block accordion active active-block">
                                    <div className="acc-btn active">
                                        High Standards
                                        <span className="arrow"></span>
                                    </div>
                                    <div className="acc_body current" style={{ display: 'block' }}>
                                        <div className="content">
                                            <p>At Om Softwares, we adhere to the highest industry standards to deliver exceptional digital solutions. Our commitment to excellence ensures every project is crafted with precision, reliability, and superior quality.</p>
                                        </div>
                                    </div>
                                </li>
                                <li className="accordion block">
                                    <div className="acc-btn">
                                        Focus on People
                                        <span className="arrow"></span>
                                    </div>
                                    <div className="acc_body">
                                        <div className="content">
                                            <p>We believe in empowering people—our clients, partners, and team members. By understanding your unique needs, we create personalized solutions that drive success and foster long-lasting relationships.</p>
                                        </div>
                                    </div>
                                </li>
                                <li className="accordion block">
                                    <div className="acc-btn">
                                        Different Thinking
                                        <span className="arrow"></span>
                                    </div>
                                    <div className="acc_body">
                                        <div className="content">
                                            <p>Innovation is at the heart of Om Softwares. We embrace unconventional ideas and explore fresh perspectives to design creative solutions that set you apart in the competitive digital landscape.</p>
                                        </div>
                                    </div>
                                </li>
                                <li className="accordion block">
                                    <div className="acc-btn">
                                        Business Innovation
                                        <span className="arrow"></span>
                                    </div>
                                    <div className="acc_body">
                                        <div className="content">
                                            <p>Transform your business with cutting-edge technology and strategic innovations from Om Softwares. Our goal is to redefine possibilities and help you stay ahead in a fast-evolving market.</p>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="faq-img bg_img ukiyo" data-u-speed="1" data-background="assets/img/about/services-hero.webp"></div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SrServiceFaq;